var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanguageIconDd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.801,
    height: 11.459,
    viewBox: "0 0 10.801 11.459",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "languageIconDd",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3272",
    "data-name": "Path 3272",
    d: "M10.3.5v9.752L8.468,8.419H.5V.5Z",
    transform: "translate(-0.5 -0.5)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3276",
    "data-name": "Path 3276",
    d: "M21.065,12.7v.687h-.687a4.362,4.362,0,0,1-3.567,3.6V16.3a3.65,3.65,0,0,0,2.863-2.912H16.5V12.7h4.565Z",
    transform: "translate(-13.882 -10.704)",
    fill: "var(--mainColor)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3277",
    "data-name": "Path 3277",
    d: "M24.123,23.109v.7A4.345,4.345,0,0,1,20.9,20.9h.72A3.614,3.614,0,0,0,24.123,23.109Z",
    transform: "translate(-17.562 -17.562)",
    fill: "var(--mainColor)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageIconDd);
export default __webpack_public_path__ + "static/media/languageIconDd.c142b8277673f084a44eb13792a5d8a2.svg";
export { ForwardRef as ReactComponent };